import {
  LOAD_INCIDENTS,
  RESOLVE_INCIDENT,
  unloadIncidentsAction,
} from "fleet/redux-store/ui-state/incidents/actions";
import { incidentsSelector } from "fleet/redux-store/ui-state/incidents/selectors";
import { IncidentsList } from "fleet/view/incidents/list";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { usersSelector } from "redux-store/users/selectors";
import { storesReady } from "redux-store/utils";

function mapStateToProps(state) {
  const storesLoaded = storesReady(state.global.users, state.pages.incidents);
  const users = usersSelector(state);
  const incidents = incidentsSelector(state);

  return {
    incidents,
    storesLoaded,
    users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resolveIncident: (serviceArgs) => {
      const { incidentId, data } = serviceArgs;
      return createPromiseApiAction(dispatch, RESOLVE_INCIDENT, [
        incidentId,
        data,
      ]);
    },
    loadIncidents: () => {
      return createPromiseApiAction(dispatch, LOAD_INCIDENTS);
    },
    unloadIncidents: () => {
      dispatch(unloadIncidentsAction);
    },
  };
}

const ConnectedIncidentsList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(IncidentsList);

export { ConnectedIncidentsList };
